import { render, staticRenderFns } from "./simOpenXy8.vue?vue&type=template&id=5e47d9d5&scoped=true&"
import script from "./simOpenXy8.vue?vue&type=script&lang=js&"
export * from "./simOpenXy8.vue?vue&type=script&lang=js&"
import style0 from "./simOpenXy8.vue?vue&type=style&index=0&id=5e47d9d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47d9d5",
  null
  
)

export default component.exports